import { toast } from "react-toastify";
import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import ApiResponse from "sr/models/ApiResponse";
import { put } from "sr/utils/axios";

interface ChangeContactPayload {
  corporateId: string;
  email?: string;
  mobile_number?: string;
}

export const changeContact = async (data: ChangeContactPayload) => {
  const { corporateId, ...payload } = data;

  try {
    const res = await put<ApiResponse<any>>(
      `/corporate/phone_email/${corporateId}`,
      payload 
    );

    if (res.success === true) {
      toast.success(res.message || "Contact updated successfully");
      return res;
    } else {
      toast.error(res.error?.message || "Failed to update contact");
      return res;
    }
  } catch (e: any) {
    HandleApiError(e);
    return null;
  }
};
